const KategoriKegiatanSearchCategories = ["pk", "nama_kategori_kegiatan"];

export default KategoriKegiatanSearchCategories;
